import React from 'react';
import Spinner from 'react-bootstrap/Spinner';
import Lottieplayer from '../commanComponent/Lottieplayer';
import GluepleAnimation2 from '../../images/UpdatedGluepleAnimation1.json';

const CustomSpinner = ({ isShow = false, size = 'md', ...props }) => {
  if (!isShow) return null;

  let divStyles = {};
  let loaderStyles = {};

  switch (size) {
    case 'sm': // Button
      loaderStyles = {
        width: "22px",
        height: "22px",
        verticalAlign: "-0.125em",
        border: ".2em solid currentColor",
        borderRightColor: "transparent",
      };
      break;

    case 'md': // Medium general
      loaderStyles = {
        width: "50px",
        height: "50px",
        zIndex: 2,
        display: "flex",
      };
      break;

    case 'xl': // Table
      divStyles = {
        margin: "40px 0px",
        width: "100%",
        textAlign: "center",
      };
      loaderStyles = {
        width: "60px",
        height: "60px",
        zIndex: 2,
      };
      break;

    case 'lg': // Page loader with Lottie
      divStyles = {
        position: 'absolute',
        top: '25%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 9999,
      };
      loaderStyles = {
        width: '100px',
        height: '100px',
        zIndex: 2,
      };
      break;

    default:
      loaderStyles = {
        width: "40px",
        height: "40px",
        zIndex: 2,
      };
  }

  return (
    <div className={size === 'lg' ? 'spinnerDiv' : ''} style={divStyles}>
      {size === 'lg' ? (
        <Lottieplayer
          lottieUrl={GluepleAnimation2}
          Lottiestyle={loaderStyles}
        />
      ) : (
        <Spinner animation="border" style={loaderStyles} {...props} />
      )}
    </div>
  );
};

export default CustomSpinner;
